// extracted by mini-css-extract-plugin
export default {"topTitle":"TermsConditions-module__topTitle--ghWw5"};